import { render, staticRenderFns } from "./comp-label.vue?vue&type=template&id=ed35acf4&scoped=true&"
import script from "./comp-label.vue?vue&type=script&lang=js&"
export * from "./comp-label.vue?vue&type=script&lang=js&"
import style0 from "./comp-label.vue?vue&type=style&index=0&id=ed35acf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed35acf4",
  null
  
)

export default component.exports